export default __webpack_public_path__ + "static/media/ChatGPT_Illustration.1ba36bcd.png";